'use client'

import { useState } from 'react'

import { Box } from '@chakra-ui/react'

import type { ColorScheme } from '../../types'
import { IconButton } from '../Button'
import { CloseIcon, SearchIcon } from '../Icon'
import { TextInput } from '../TextInput'

export type TableToolbarProps = {
  value: string
  onChange: (value: string) => void
  colorScheme?: ColorScheme
  maxWidth?: string
  placeholder?: string
  actions?: React.ReactNode
}

export const TableToolbar = ({
  value,
  onChange,
  colorScheme = 'dark',
  maxWidth,
  placeholder,
  actions,
}: TableToolbarProps) => {
  const [isSearchOpen, setIsSearchOpen] = useState(false)

  const handleSearchClose = () => {
    if (!value) setIsSearchOpen(false)
  }

  return (
    <Box
      alignItems='center'
      display='flex'
      height={14}
      justifyContent='space-between'
      margin='0 auto'
      maxWidth={maxWidth}
      width='100%'
    >
      {isSearchOpen ? (
        <Box width='286px'>
          <TextInput
            actionButton={
              <IconButton
                aria-label='Close search'
                colorScheme={colorScheme}
                dimension={12}
                hoverBgColor='transparent'
                icon={<CloseIcon colorScheme={colorScheme} size={12} />}
                onClick={() => {
                  onChange('')
                  setIsSearchOpen(false)
                }}
              />
            }
            autoFocus
            colorScheme={colorScheme}
            leftIcon={<SearchIcon colorScheme={colorScheme} size={12} />}
            onChange={(e) => onChange(e.target.value)}
            onSubmit={handleSearchClose}
            placeholder={placeholder}
            value={value}
            width='100%'
          />
        </Box>
      ) : (
        <Box>
          <IconButton
            aria-label='Search'
            colorScheme={colorScheme}
            dimension={36}
            icon={<SearchIcon colorScheme={colorScheme} />}
            onClick={() => setIsSearchOpen(true)}
          />
        </Box>
      )}
      {actions && <Box alignItems='center'>{actions}</Box>}
    </Box>
  )
}
